@if (employmentType()) {
  <ct-lib-tag [accentColor]="colorService.accent">
    <fa-icon [icon]="fontawesomeService.regular.suitcase"></fa-icon>
    {{
      constantsService.getLabelByValue(
        constantsService.employmentTypeConstants,
        employmentType()
      ) | transloco
    }}
  </ct-lib-tag>
}
@if (workingTime()) {
  <ct-lib-tag [accentColor]="colorService.accent">
    <fa-icon [icon]="fontawesomeService.regular.clock"></fa-icon>
    {{
      constantsService.getLabelByValue(
        constantsService.workingHoursConstants,
        workingTime()
      ) | transloco
    }}
  </ct-lib-tag>
}
@switch (workingModel()) {
  @case (WorkingModel.ON_SITE) {
    @if (filteredLocations().length > 0) {
      <ct-lib-tag [accentColor]="colorService.accent">
        <fa-icon [icon]="fontawesomeService.regular.mapMarkerAlt"></fa-icon>
        {{ facilityString() }}
      </ct-lib-tag>
    } @else {
      <ct-lib-tag [accentColor]="colorService.accent">
        <fa-icon [icon]="fontawesomeService.regular.mapMarkerAlt"></fa-icon>
        {{ 'jobboard.views.jobboard.list.remote' | transloco }}
      </ct-lib-tag>
    }
  }
  @case (WorkingModel.HYBRID) {
    <ct-lib-tag [accentColor]="colorService.accent">
      <fa-icon [icon]="fontawesomeService.regular.mapMarkerAlt"></fa-icon>
      {{ 'jobboard.views.jobboard.list.hybrid' | transloco }}
      {{ facilityString() }}
    </ct-lib-tag>
  }
  @case (WorkingModel.FIELD_SERVICE) {
    <ct-lib-tag [accentColor]="colorService.accent">
      <fa-icon [icon]="fontawesomeService.regular.mapMarkerAlt"></fa-icon>
      {{ 'jobboard.views.jobboard.list.field-service' | transloco }}
      {{ facilityString() }}
    </ct-lib-tag>
  }
  @case (WorkingModel.REMOTE) {
    <ct-lib-tag [accentColor]="colorService.accent">
      <fa-icon [icon]="fontawesomeService.regular.mapMarkerAlt"></fa-icon>
      {{ 'jobboard.views.jobboard.list.remote' | transloco }}
      {{ facilityString() }}
    </ct-lib-tag>
  }
}
@if (startDate()) {
  <ct-lib-tag [accentColor]="colorService.accent">
    <fa-icon [icon]="fontawesomeService.regular.calendarAlt"></fa-icon>
    {{
      timestampInPast()
        ? ('jobboard.snippets.header-tags.next-possible-date' | transloco)
        : ('jobboard.snippets.header-tags.from' | transloco) +
          (startDate() | unixToDate)
    }}
  </ct-lib-tag>
}
@if (showJobboardSalaryTag()) {
  <ct-lib-tag [accentColor]="colorService.accent">
    <fa-icon [icon]="fontawesomeService.regular.moneyBillWave"></fa-icon>
    @if (displayJobboardSalaryMin() === displayJobboardSalaryMax()) {
      {{
        displayJobboardSalaryMin()!
          | currency: (salaryCurrency() ?? 'EUR') : 'symbol' : '1.0-0'
      }}
    } @else {
      {{
        displayJobboardSalaryMin()!
          | currency: (salaryCurrency() ?? 'EUR') : 'symbol' : '1.0-0'
      }}
      –
      {{
        displayJobboardSalaryMax()!
          | currency: (salaryCurrency() ?? 'EUR') : 'symbol' : '1.0-0'
      }}
    }
    @if (salaryInterval() != null) {
      {{
        constantsService.getLabelByValue(
          constantsService.salaryIntervalConstants,
          salaryInterval()!
        ) | transloco
      }}
    }
  </ct-lib-tag>
}
@if (website()) {
  <a [href]="website()" target="_blank" (click)="$event.stopPropagation()">
    <ct-lib-tag [accentColor]="colorService.accent">
      <fa-icon [icon]="fontawesomeService.regular.externalLink"></fa-icon>
      {{ 'jobboard.static.header.website' | transloco }}
    </ct-lib-tag>
  </a>
}
